/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ReactNode } from 'react';
import { Node } from '@msdyn365-commerce-modules/utilities';
import { IMoeArticleListViewProps } from './moe-article-list';

export const articleListView: React.FC<IMoeArticleListViewProps> = props => {
    const { title, tiles, tileListContainer, tileListHeading, tileItemContainer } = props;
    return (
        <div tabIndex={0} className='ms-article-list-wrap'>
            <Node {...tileListContainer}>
                {title && <Node {...tileListHeading}>{title}</Node>}
                <ul className='ms-article-list'>
                    {tiles.map((tileItem: ReactNode, index: number) => {
                        const keyIndex = `tile-list-item__${index}`;
                        return (
                            <Node {...tileItemContainer} key={keyIndex}>
                                {tileItem}
                            </Node>
                        );
                    })}
                </ul>
            </Node>
        </div>
    );
};

export default articleListView;
